'use client'

import { useState } from 'react'

// "Stay current" box at the bottom of the P2 workflow hubs. Until 2026-08-20 this
// was a handler-less demo form left over from the static generator — emails typed
// here went nowhere. Now posts to the same endpoint as the site-wide
// NewsletterSignup (general audience → Klaviyo "EA Website" list → Welcome
// Series). Class names match p2.css (.news-form) so the hub styling is unchanged.
export function P2NewsForm() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle')

  if (status === 'success') {
    return (
      <p className="news-form-done" role="status">
        You&rsquo;re in &mdash; you&rsquo;ll get a confirmation email within the next 10 minutes.
      </p>
    )
  }

  return (
    <form
      className="news-form"
      onSubmit={async (e) => {
        e.preventDefault()
        if (!email) return
        setStatus('loading')
        try {
          const res = await fetch('/api/newsletter/subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, audienceType: 'general' }),
          })
          if (!res.ok) throw new Error(`subscribe ${res.status}`)
          setStatus('success')
        } catch (err) {
          console.error('[p2 news-form] subscribe failed', err)
          setStatus('error')
        }
      }}
    >
      <input
        type="email"
        name="email"
        autoComplete="email"
        placeholder="you@company.com"
        aria-label="Email address"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={status === 'loading'}
      />
      <button type="submit" disabled={status === 'loading' || !email}>
        {status === 'loading' ? 'Sending…' : 'Notify me'}
      </button>
      {status === 'error' && (
        <p className="news-form-error" role="alert">
          Something went wrong. Please try again.
        </p>
      )}
    </form>
  )
}
